export default[
    {
        path: '/cbo/cadastro',
        name: 'cadastro de cbo', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/cbo/lista',
        name: 'lista de cbo', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/cbo/editar/:id',
        name: 'editar cbo', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]